import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private requestCount = signal(0);
  isLoading = this.requestCount.asReadonly();

  startLoading() {
    setTimeout(() => {
      this.requestCount.update((count) => count + 1);
    }, 0);
  }

  stopLoading() {
    setTimeout(() => {
      this.requestCount.update((count) => (count > 0 ? count - 1 : 0));
    }, 0);
  }

  resetLoading() {
    setTimeout(() => {
      this.requestCount.set(0);
    }, 0);
  }
}